import React, { Component } from "react";
import { Modal } from "antd";
import ResultModalRender from "./children/ResultModalRender";

export default class ResultModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { visible, width, onClose } = this.props;
    return (
      <Modal centered maskClosable={false} visible={visible} title={null} footer={null} width={width ? width : 460} onCancel={onClose}>
        <ResultModalRender {...this.props} />
      </Modal>
    );
  }
}
